// TODO: why is this not available from the root?
export var NavType;

(function (NavType) {
  NavType["home"] = "home";
  NavType["books"] = "books";
  NavType["study"] = "study";
  NavType["writing"] = "writing";
  NavType["flashcards"] = "flashcards";
  NavType["math-solver"] = "math-solver";
  NavType["internships"] = "internships";
  NavType["test-prep"] = "test-prep";
  NavType["scholarships"] = "scholarships";
  NavType["money"] = "money";
  NavType["faculty"] = "faculty";
  NavType["uversity"] = "uversity";
})(NavType || (NavType = {}));

export var ExplicitlyHideSearchBar = 'explicitlyHideSearchOnThisPage';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/types.js
// module id = 179
// module chunks = 11